interface Stat {
  value: string;
  label: string;
}

interface StatsSectionProps {
  stats: Stat[];
  columns?: 2 | 3 | 4;
}

const colsClass = { 2: "md:grid-cols-2", 3: "md:grid-cols-3", 4: "md:grid-cols-2 lg:grid-cols-4" };

const StatsSection = ({ stats, columns = 4 }: StatsSectionProps) => {
  return (
    <div className={`grid grid-cols-2 ${colsClass[columns]} gap-10 md:gap-14`}>
      {stats.map((stat, i) => (
        <div key={i} className="text-center">
          <span className="block font-headline text-5xl md:text-6xl text-accent leading-none">
            {stat.value}
          </span>
          <span className="block font-body text-sm uppercase tracking-widest text-muted-foreground mt-4">
            {stat.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;
